export const TITLE_BG = 'transparent'
export const GET_TICKETS_BG = 'black'
export const CHECK_PRIZES_BG = 'black'
export const FINISHED_ROUNDS_BG = 'black'
// linear-gradient(180deg, #CBD7EF 0%, #9A9FD0 100%)'
export const FINISHED_ROUNDS_BG_DARK = 'black'
